<template>
  <div class="navigation-main">
    <ul>
      <li v-for="item in this.$store.getters.mainMenu" :key="item.id" >
        <a :ref="'main-'+item.id"
           :href="item.url"
           :class="[item.hasSub ? subLinkClass : '',item.active ? activeLinkClass : '',item.current ? currentLinkClass : '' ]"
           v-on:click="activateMenuItem($event,item)">
          {{ item.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'MainMenu',
  data() {
    return {
      subLinkClass: 'has-sub',
      activeLinkClass: 'active',
      currentLinkClass:'current'
    }
  },
  methods: {
    activateMenuItem(event,item){
      const ref = 'main-' + item.id;
      if (item.hasSub){
        event.preventDefault();
        const elementInformation = {
          id:item.id,
          positionLeft: this.$refs[ref].getBoundingClientRect().left,
        }
        this.$store.commit('setMainMenuElementActive', elementInformation);
      }
    },
  },
  beforeMount() {
    if (process.env.NODE_ENV==='development'){
      import('./assets/Private/Css/styles.css');
    }
    this.$store.dispatch('loadMenuItems');
  }
}
</script>


